import React from 'react'
import mustacheImg from "./../../../../Images/HairSalonInnerPage/Mustache Styling.png";

const MustacheImg = () => {
  return (
    <div className="haircutImg">
      <img src={mustacheImg} alt="mustacheImg" />
    </div>
  )
}

export default MustacheImg
